import { html, LitElement, PropertyValues, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

@customElement('app-map-base')
export class MapBase extends LitElement {
    @property({ type: Number }) k_lat = -98.4213249171453;
    @property({ type: Number }) k_lng = 21.139080926277327;
    @property({ type: Number }) k_zoom = 15;

    protected map!: L.Map;

    protected createRenderRoot() {
        return this;
    }

    connectedCallback(): void {
        super.connectedCallback();
        this.style.display = 'block';
        this.style.width = '100%';
        this.style.height = '100%';
    }

    firstUpdated() {
        const mapContainer = this.querySelector('.leaflet-container') as HTMLElement;
        if (!mapContainer) return;

        this.map = L.map(mapContainer, { zoomDelta: 1, }).setView([this.k_lat, this.k_lng], this.k_zoom);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.map);

        this.dispatchEvent(new CustomEvent('map-ready', { detail: { map: this.map } }));
    }

    updated(_changedProperties: PropertyValues): void {
        super.updated(_changedProperties);

        if (!this.map) return;

        const locationChanged = _changedProperties.has('k_lat') || _changedProperties.has('k_lng');
        const zoomChanged = _changedProperties.has('k_zoom');

        if (locationChanged || zoomChanged) {
            this.map.setView([this.k_lat, this.k_lng], this.k_zoom);
        }
    }

    render() {
        return html`
            <div class='leaflet-container' style='height: 100%; width: 100%; min-height: 250px; border-radius: 8px;'></div>
        `
    }
}